export const EXCLUDED_SLOTS: string[] = [];
export const MORNING_LAB_SLOTS = Array.from({ length: 30 }, (_, i) => `L${i + 1}`);
export const EVENING_LAB_SLOTS = Array.from({ length: 30 }, (_, i) => `L${i + 31}`);

export const morningTheorySlotsConst = ['TAA1', 'C1', 'B1', 'D1', 'G1', 'TF1', 'TDD1', 'E1', 'F1', 'A1', 'TG1', 'TCC1', 'TB1', 'TE1', 'TC1', 'TBB1', 'TA1', 'TD1'];
export const eveningTheorySlotsConst = ['G2', 'B2', 'C2', 'D2', 'TAA2', 'D2', 'A2', 'TF2', 'E2', 'TDD2', 'F2', 'TG2', 'TB2', 'TCC2', 'TD2', 'TC2', 'TBB2', 'TA2', 'TE2'];

export const dayRows = [
  {
    day: 'TUE',
    slots: ['TAA1/L1', 'C1/L2', 'B1/L3', 'D1/L4', 'G1/L5', 'L6', 'G2/L31', 'B2/L32', 'C2/L33', 'D2/L34', 'TAA2/L35', 'L36']
  },
  {
    day: 'WED',
    slots: ['TF1/L7', 'B1/L8', 'C1/L9', 'A1/L10', 'D1/L11', 'L12', 'D2/L37', 'C2/L38', 'A2/L39', 'B2/L40', 'TF2/L41', 'L42']
  },
  {
    day: 'THU',
    slots: ['TG1/L13', 'TDD1/L14', 'E1/L15', 'F1/L16', 'A1/L17', 'L18', 'E2/L43', 'TDD2/L44', 'A2/L45', 'F2/L46', 'TG2/L47', 'L48']
  },
  {
    day: 'FRI',
    slots: ['TCC1/L19', 'G1/L20', 'F1/L21', 'E1/L22', 'TB1/L23', 'L24', 'TB2/L49', 'E2/L50', 'F2/L51', 'G2/L52', 'TCC2/L53', 'L54']
  },
  {
    day: 'SAT',
    slots: ['TE1/L25', 'TC1/L26', 'TBB1/L27', 'TA1/L28', 'TD1/L29', 'L30', 'TD2/L55', 'TC2/L56', 'TBB2/L57', 'TA2/L58', 'TE2/L59', 'L60']
  }
];

export const theoryTimes = [
  "08:00AM\nto\n08:50AM",
  "09:00AM\nto\n09:50AM",
  "10:00AM\nto\n10:50AM",
  "11:00AM\nto\n11:50AM",
  "12:00PM\nto\n12:50PM",
  "12:51PM\nto\n01:30PM",
  "02:00PM\nto\n02:50PM",
  "03:00PM\nto\n03:50PM",
  "04:00PM\nto\n04:50PM",
  "05:00PM\nto\n05:50PM",
  "06:00PM\nto\n06:50PM",
];

export const labTimes = [
  "08:00AM\nto\n08:50AM",
  "08:51AM\nto\n09:40AM",
  "10:00AM\nto\n10:50AM",
  "10:51AM\nto\n11:40AM",
  "12:00PM\nto\n12:50PM",
  "12:51PM\nto\n01:30PM",
  "02:00PM\nto\n02:50PM",
  "02:51PM\nto\n03:40PM",
  "04:00PM\nto\n04:50PM",
  "04:51PM\nto\n05:40PM",
  "06:00PM\nto\n06:50PM",
  "06:51PM\nto\n07:30PM"
]; 